import React, { useState, useEffect } from 'react';
import { Icon } from "@iconify/react";
import { CreateLinkLoadingGIF, quickImg } from "@/config/config";
import useLanguage from "@/hooks/useLanguage";
import styles from './index.module.scss';

const Modal = ({ type, outLogin, children, cancel, getCapInvite, reEligible, footerBotton }) => {
  const { t } = useLanguage();

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  return <div className={styles.modal}>
    <div className={styles.content}>
      <div className={styles.cancel}>
        <Icon icon='line-md:close' className={styles.cancelIcon} onClick={(e) => { e.stopPropagation(); cancel(); }} />
      </div>
      {type === 'loading' && <img src={CreateLinkLoadingGIF} className={styles.loadingIcon} />}
      {type === 'success' && <Icon icon='mdi:checkbox-marked-circle-auto-outline' className={styles.successIcon} />}
      {type === 'sample' && <img className='w-[151px] h-[100px]' src={"/static/getSample.png"} alt={""} />}
      {type === 'quickTips' && <img className='w-[116px] h-[94px]' src={quickImg} alt={""} />}
      {!type && <Icon icon='material-symbols:brightness-alert-rounded' className={styles.tipIcon} />}
      {(type !== 'sample' && type !== 'quickTips') && <div className={styles.text}>
        {children}
      </div>}
      {type === 'sample' && <div className={styles.sampleInfo}>
        <div className={styles.infoTitle}>
          {t('modal_h5.join_program')}
        </div>
        <ul>
          <li className={styles.infoText} style={{ marginTop: '8px' }}>{t('modal_h5.ready_to_join')}
            <span className={styles.infoTextDiff}>{t('modal_h5.highest_commissions1')}</span> {t('modal_h5.highest_commissions2')}, <span className={styles.infoTextDiff}>{t('modal_h5.offline_samples')}</span>,
            <span className={styles.infoTextDiff}>{t('modal_h5.exclusive_boost')}</span>, {t('modal_h5.personalized_support1')}
            <span className={styles.infoTextDiff}>{t('modal_h5.personalized_support2')}</span>, {t('modal_h5.tiktok_flash_sales')}.</li>
          <li className={styles.infoText}>{t('modal_h5.click_button1')}
            <span className={styles.infoTextDiff}>{t('modal_h5.click_button2')}</span> {t('modal_h5.click_button3')}
            <span className={styles.infoTextDiff}>{t('modal_h5.click_button4')}</span>
          </li>
        </ul>
        <div className={styles.footerBox}>
          <div className={styles.submit} onClick={getCapInvite}>{t('modal_h5.obtain_eligibility')}</div>
          <div className={styles.cancel} onClick={reEligible}>{t('modal_h5.already_eligible')}</div>
        </div>
      </div>}
      {type === 'quickTips' && <div className={styles.sampleInfo}>
        <div className={styles.quickTipsTitle}>
          {t('modal_h5.add_shortcut')}
        </div>
        <div >
          <ul>
            <li className={styles.infoText} style={{ marginTop: '8px' }}>
              <span className={styles.infoTextDiff}>Chrome: </span>{t('modal_h5.chrome_tip')}</li>
            <li className={styles.infoText}>
              <span className={styles.infoTextDiff}>Safari: </span>{t('modal_h5.safari_tip')}</li>
          </ul>
          <div className={styles.quickFooter} onClick={cancel}>{t('modal_h5.i_get_it')}</div>
        </div>
      </div>}
      {footerBotton && <div className={styles.wrap}>
        <div className={styles.leftBotton} onClick={outLogin}>{t('modal_h5.yes')}</div>
        <div className={styles.rightBotton} onClick={(e) => { e.stopPropagation(); cancel(); }}>{t('modal_h5.no')}</div>
      </div>}
    </div>
  </div >;
};
export default Modal;